import { useMainStore } from "@/store"



// 单位格式化
export function formatUnit(value: string) {
    if (value == 'USD') {
        return '$'
    } else {
        return 'ARS'
    }
}
// 币种转换
// export function formatStockType(value: string) {
//     if (value == 'USD') {
//         return '美股'
//     } else {
//         return '阿根廷'
//     }
// }
// 汇率转换
export function exchangeRateConvert(
    amount: number,          // 金额
    rate: number,            // 汇率（例如 USD→CNY 汇率 7.2）
    reverse: boolean = false, // false = 正常换算，true = 逆向换算
    decimals: number = 2     // 保留小数位
): any {

    if (!rate || isNaN(rate)) return 0;
    if (rate == 0) return '--'
    if (!amount || isNaN(amount)) return 0;
    const mainStore = useMainStore()
    const oldRate = mainStore.rate
    if (oldRate != rate) {
        mainStore.setRate(rate)
    }

    const result = reverse
        ? amount / rate   // 逆向：目标金额 → 基础货币
        : amount * rate;  // 正向：基础货币 → 目标金额
    if (reverse) {
        decimals = 3
        return result.toFixed(decimals);
    } else {
        return result.toFixed(decimals);
    }
}
// 保留小数位数（默认 3 位）
export function formatNumber(value: any, decimals: number = 3) {
    const num = Number(value)
    // 非数字情况直接返回 0
    if (isNaN(num)) return '0'
    return num.toFixed(decimals)
}

/**
 * 判断当前时间是否在每日指定时间范围内
 * @param startTime "09:00:00"
 * @param endTime   "22:00:00"
 * @returns boolean
 */
export function isInTimeRange(startTime: string, endTime: string): boolean {
    if (!startTime || !endTime) {
        return false;
    }

    // 当前时间（阿根廷时间 UTC-3）
    const now = new Date();
    const argentinaNow = new Date(
        now.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" })
    );

    // 构造今日阿根廷时间的开始时间
    const [sh, sm, ss] = startTime.split(":").map(Number);
    const start = new Date(argentinaNow);
    start.setHours(sh, sm, ss, 0);

    // 构造阿根廷时间的结束时间
    const [eh, em, es] = endTime.split(":").map(Number);
    const end = new Date(argentinaNow);
    end.setHours(eh, em, es, 0);

    return argentinaNow >= start && argentinaNow <= end;
}

export function getCountDown(expireTime: string) {
    // 当前时间（转换为阿根廷 UTC -3）
    const now = new Date();
    const nowArg = new Date(now.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" }));

    // 到期时间（按阿根廷时间解析）
    const target = new Date(
        new Date(expireTime).toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" })
    );

    let diff = Math.max(0, target.getTime() - nowArg.getTime());

    const hours = Math.floor(diff / (1000 * 60 * 60));
    diff -= hours * 1000 * 60 * 60;

    const minutes = Math.floor(diff / (1000 * 60));
    diff -= minutes * 1000 * 60;

    const seconds = Math.floor(diff / 1000);

    return {
        hours,
        minutes,
        seconds,
    };
}

/**
* 计算阿根廷时间倒计时
* @param expireTime string 例如 "2025-12-10 15:00:00"
* @returns { days, hours, minutes, seconds }
*/
export function getArgCountdown(expireTime: string) {
    if (!expireTime) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

    // 👉 处理 15-12-2025 18:00:00 这种格式
    const [datePart, timePart = "00:00:00"] = expireTime.split(" ");
    const [dd, mm, yyyy] = datePart.split("-");
    const standardFormat = `${yyyy}-${mm}-${dd} ${timePart}`; // 转成标准格式

    // 当前时间（阿根廷时区）
    const now = new Date();
    const nowArg = new Date(
        now.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" })
    );

    // 目标时间（按阿根廷时区解析）
    const targetArg = new Date(
        new Date(standardFormat).toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" })
    );

    // 毫秒差值
    let diff = Math.max(0, targetArg.getTime() - nowArg.getTime());

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    diff -= days * 1000 * 60 * 60 * 24;

    const hours = Math.floor(diff / (1000 * 60 * 60));
    diff -= hours * 1000 * 60 * 60;

    const minutes = Math.floor(diff / (1000 * 60));
    diff -= minutes * 1000 * 60;

    const seconds = Math.floor(diff / 1000);

    return {
        days,
        hours,
        minutes,
        seconds,
    };
}


// 判断 token 是否过期（使用阿根廷时间）
export function isTokenExpired(token: String) {
    if (!token) return true;

    try {
        // 解析 JWT 的 payload
        const payload = JSON.parse(atob(token.split(".")[1]));

        // exp 是 Unix 秒时间戳
        const exp = payload.exp;

        if (!exp) return true;

        // 当前阿根廷时间（毫秒 -> 秒）
        const nowArgentina = new Date().toLocaleString("en-US", {
            timeZone: "America/Argentina/Buenos_Aires"
        });
        const nowSeconds = Math.floor(new Date(nowArgentina).getTime() / 1000);

        // 判断是否过期
        return nowSeconds >= exp;

    } catch (e) {
        console.error("Token parse error:", e);
        return true; // 解析失败当作已过期
    }
}





